<template>
    <div class="mb-3  text-start">
        <div class="row">

            <div class="col-12 col-md-6">
                <label for="firstName" class="form-label">First Name</label>
                <input type="text" class="form-control" id="firstNameInput" aria-describedby="emailHelp"
                    v-model="firstName">

            </div>

            <div class="col-12 col-md-6">
                <label for="lastName" class="form-label">Last Name</label>
                <input type="text" class="form-control" id="lastNameInput" aria-describedby="emailHelp"
                    v-model="lastName">
            </div>
        </div>
        <div class="row">

            <div class="col-12">
                <label for="experienceDetails" class="form-label">Comments</label>
                <textarea name="experienceDetails" class="form-control" id="emailInput" aria-describedby="emailHelp"
                    v-model="comments"></textarea>
</div>
  </div>
  <button type="submit" class="btn btn-warning mt-3 align_center" @click="this.$emit('submit',comments,firstName,lastName)">Send Feedback</button>
</div>
</template>

<script>
export default{
    name:"SendFeedbackForm",
    data(){
        return{
        firstName:"",
        lastName:"",
        comments:""
        }
    }
}
</script>

<style scoped>
.align_center{
margin-left: auto;
margin-right: auto;
}
</style>